<rds-avatar [rdsTooltip]="user.name" [rdsTooltipShowDelay]="300">
  <img *ngIf="!!user.avatar" rds-avatar-image [src]="user.avatar" referrerpolicy="no-referrer"/>
  <span *ngIf="!user.avatar" rds-avatar-initials>{{user.name | initials}}</span>
</rds-avatar>